import { render, staticRenderFns, recyclableRender, components } from "./stockQuery.vue?vue&type=template&id=8e7c7f1a&"
var renderjs
import script from "./stockQuery.vue?vue&type=script&lang=js&"
export * from "./stockQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!C:\\Users\\dell\\Downloads\\HBuilderX.3.2.16.20211122.full\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/basics/stockQuery.vue"
export default component.exports